import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors as configSelectors } from '../../infrastructure/config';
import { selectors as caseSelectors } from '../../infrastructure/cases';
import AboutBusinessPage from './components/AboutBusinessPage';
import {
  dataCaptureSelectors,
  saveBusinessForm,
  redirectToBusinessAccount,
  onAddressSelection,
  saveAboutYourFormValues,
  onAddressEditClick
} from '../../store/dataCapture';
import {
  NAVIGATION_BACK,
  TRADING_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE,
  REGISTER_ADDRESS_TYPE
} from '../../utils/constants';
class AboutBusinessQuestion extends Component {
  constructor(props) {
    super(props);
    this.backClick = this.backClick.bind(this);
  }

  backClick() {
    this.props.redirectToBusinessAccount(NAVIGATION_BACK);
  }

  render() {
    return <AboutBusinessPage {...this.props} backClick={this.backClick} />;
  }
}

AboutBusinessQuestion.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  isSoleBusinessType: PropTypes.bool.isRequired,
  saveBusinessForm: PropTypes.func,
  findAddress: PropTypes.func,
  lookUpRegisterDetails: PropTypes.shape([]),
  lookUpTradingDetails: PropTypes.shape([]),
  lookUpMailingDetails: PropTypes.shape([]),
  onClickAddress: PropTypes.func,
  onAddManuallyClick: PropTypes.func,
  getCustomerData: PropTypes.object
};

const mapStateToProps = (state) => ({
  brandId: configSelectors.brandId(state),
  bankId: configSelectors.bankId(state),
  businessId: caseSelectors.business_uuid(state),
  isSoleBusinessType:
    configSelectors.isSoleTrader(state) || dataCaptureSelectors.isSoleBusinessType(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state),
  getCustomerData: dataCaptureSelectors.getCustomerData(state),
  address: caseSelectors.getAddress(state),
  registerAddress: dataCaptureSelectors.getRegisterAddress(state),
  tradingAddress: dataCaptureSelectors.getAddressByType(state, TRADING_ADDRESS_TYPE),
  mailingAddress: dataCaptureSelectors.getAddressByType(state, MAILING_ADDRESS_TYPE),
  editButtonClicks: {
    registerEditClick: dataCaptureSelectors.getEditClickByType(state, REGISTER_ADDRESS_TYPE),
    tradingEditClick: dataCaptureSelectors.getEditClickByType(state, TRADING_ADDRESS_TYPE),
    mailingEditClick: dataCaptureSelectors.getEditClickByType(state, MAILING_ADDRESS_TYPE)
  }
});

const actionCreators = {
  saveBusinessForm,
  redirectToBusinessAccount,
  onAddressSelection,
  saveAboutYourFormValues,
  onAddressEditClick
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AboutBusinessQuestion);
